import { Box, Card, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import Dropdown from "./DropDown";
import cssClasses from "./Leadcard.module.css";
import LeadStatusChip from "./LeadStatusChip";
import Dot from "../Components/Icons/Dot";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ThreeDotsMenu from "./ThreeDotsMenu";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import Button from "./Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CallIcon from "@mui/icons-material/Call";
import { difference, sortBy } from "lodash";
import Datagrid from "./Datagrid";
import { DataGrid } from "@mui/x-data-grid";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CustomInput from "./CustomInput";
import Divider from "@mui/material/Divider";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

//*Modals
import ScheduleSiteVisit from "../Modals/ScheduleSiteVisit/ScheduleSiteVisit";
import TimeLineAndNotes from "../Modals/TimeLineAndNotes/TimeLineAndNotes";
import AssignNewToken from "../Modals/AssignNewToken/AssignNewToken";
import AddPreference from "../Modals/AddPreference/AddPreference";
import ChangeToken from "../Modals/ChangeToken/ChangeToken";
import AddSiteVisit from "../Modals/AddSiteVisit/AddSiteVisit";
import LeadSourceChange from "../Modals/LeadSourceChange/LeadSourceChange";
import ChangeUnit from "../Modals/ChangeUnit/ChangeUnit";
import CancelUnit from "../Modals/CancelUnit.js/CancelUnit";
import RefundToken from "../Modals/RefundToken/RefundToken";
import UpdateLeadStatus from "../Modals/UpdateLeadStatus/UpdateLeadStatus";
import ReAssignLead from "../Modals/ReAssignLead/ReAssignLead";
import ChurnLeadRejection from "../Modals/ChurnLeadRejection/ChurnLeadRejection";
import AlotUnit from "../Modals/AlotUnit/AlotUnit";
import ViewVirtualAccDetails from "../Modals/ViewVirtualAccountDetails/viewVirtualAccDetails"
//service
import {
  updateLeadResponse,
  updateLeadVirtualAccountDetails,
} from "../Services/Lead";
import { getAllotedData } from "../Services/AlotUnit";
import { sendMailTo, sendMessage } from "../Services/SmsService";
import {
  checkPaymentStatus,
  getAssignedToken,
  getAssignedTokenForHolders,
} from "../Services/AssignNewToken";
import { errorTost, successTost } from "../Services/Toast";

import { useSelector } from "react-redux";
import {
  closeVirtualAccount,
  createPaymentLink,
  createVirtualAccount,
  getVirtualAccountStatus,
  recreateVirtualAccount,
  resendPaymentLink,
} from "../Services/PaymentApi";
import { dismissLoader, presentLoader } from "../Services/loader";
import { WhatsappIcon } from "react-share";
import UpdateLeadDetails from "../Modals/UpdateLeadDetails/UpdateLeadDetails";
import CheckVirtualAccountStatus from "../Modals/CheckVirtualAccountStatus/CheckVirtualAccountStatus";
import { useParams } from "react-router-dom";
import { getAllotmentDataForTokenHolders } from "../Services/Event";
import axios from "axios";
import ConfirmationAlert from "./ConfirmationAlert";
import ViewLeadDetailsRL from "../Modals/ViewLeadDetailsRL/ViewLeadDetailsRL";
import { toast } from "react-toastify";
import { makeCall } from "../Services/SmartFloApis";
// import { supabase } from "../supabaseClient";

// R&L leads never get "Lead Source Change" — on any tab. Individual tab
// branches below build the dropdown differently (some include it in a base
// array before role-accessibility filtering, some push it unconditionally),
// so this strips it out in one place right before it reaches state, instead
// of patching every branch's own condition.
function filterLeadSourceChangeForRnl(list, leadType) {
  return leadType === "R&L"
    ? list.filter((item) => item !== "Lead Source Change")
    : list;
}

const dataGridStyles = {
  "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
    outline: "none",
  },
  border: "1px solid #EAECF0 !important",
  fontWeight: "400",
  fontSize: "1.4rem",
  lineHeight: "2rem",
  color: "#667085",
  fontFamily: "Inter-Medium",
  borderRadius: "8px",
  '& div[data-colindex="1"]': {
    color: "#101828",
    fontWeight: "500",
  },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      borderBottom: "1px solid #EAECF0",
      background: "#FFFFFF",
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: "1rem",

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      borderBottom: "1px solid #EAECF0",
      backgroundColor: "#FFFFFF",
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  "& .MuiDataGrid-iconSeparator ": {
    display: "none",
  },
  "& .MuiDataGrid-columnHeader:hover": {
    "& .MuiDataGrid-menuIcon": {
      visibility: "hidden",
    },
  },

  "&  .MuiDataGrid-columnHeaders": {
    background: "#F9FAFB",
    /* Gray/200 */
    border: "1px solid #EAECF0",
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: "1rem",
    borderBottom: "6px solid #EAECF0",
  },
  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },
  "& .MuiDataGrid-checkboxInput": {
    "& svg": {
      width: "2rem",
      height: "2rem",
      background: "#FFFFFF",
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  "& .MuiDataGrid-footerContainer": {
    "& .MuiTablePagination-displayedRows ": {
      display: "none",
    },
    "& .MuiDataGrid-selectedRowCount": {
      visibility: "hidden ",
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: "none",
    cursor: "none",
  },
  "& [title='Go to previous page']": {
    // borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to next page']": {
    // borderRadius: "0",
    border: "1px solid #EAECF0",
    borderRadius: "0.8rem",
    marginRight: "0.5rem",
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: "1rem",
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: "1rem",
  },
  "& .MuiDataGrid-columnHeader": {
    padding: "0 4rem",

    "&:focus": {
      outline: "none",
    },
  },
  "&  .MuiDataGrid-row ": {
    maxHeight: "72px !important",
    minHeight: "72px !important",
  },
  "& .MuiDataGrid-cell": {
    padding: "0 4rem",
    minHeight: "72px !important",
    maxHeight: "72px !important",
    "&:focus": {
      outline: "none",
    },
  },
  "& .MuiButtonBase-root": {
    fontSize: "1.6rem",
  },
  "& .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
};

/* ── Match-score bucket (per CLAUDE.md: ≥85 green, 60–84 amber, <60 red) ── */
function getScoreBucket(score) {
  if (typeof score !== "number" || isNaN(score)) return null;
  if (score >= 85) return { color: "#16a34a", bg: "#f0fdf4", border: "#bbf7d0", label: "Excellent" };
  if (score >= 60) return { color: "#d97706", bg: "#fffbeb", border: "#fde68a", label: "Good" };
  return { color: "#dc2626", bg: "#fef2f2", border: "#fecaca", label: "Low" };
}


function getVerificationBadge(status) {
  if (status === "Verified")
    return { bg: "#ECFDF3", color: "#067647", border: "#ABEFC6", dot: "#17B26A", label: "Verified" };
  if (status === "Rejected")
    return { bg: "#FEF3F2", color: "#B42318", border: "#FECDCA", dot: "#F04438", label: "Rejected" };
  return { bg: "#FFFAEB", color: "#B54708", border: "#FEDF89", dot: "#F79009", label: "Verification Pending" };
}

export default function Leadcard({
  leadObj,
  setLeadObj,
  claimLead,
  tabValue,
  CardType,
  returnResLeads,
  onSelecting,
  selectMultipleLeads,
  onRegenerate,
}) {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  // "Lost" leads reuse this same card but with contact details + status actions
  // suppressed and a single Regenerate action (see CardType === "Lost" gates below).
  const lostMode = CardType === "Lost";
  // console.log(tabValue);
  TimeAgo.setDefaultLocale(en.locale);
  TimeAgo.addLocale(en);


  const leadTypeList = ["WARM", "HOT", "COLD", "LOST"];
  const [dropdownList, setDropdownList] = useState([]);
  const [allotmentDropdownList, setAllotmentDropdownList] = useState([]);
  // const [dropdownList, setDropdownList] = useState([
  //   "Schedule site visit",
  //   "Add site visit",
  //   "Assign new token",
  //   "Change Token",
  //   "Change unit",
  //   "Cancel unit",
  //   "Churn Lead",
  //   "Churn and Create Lead",
  //   "Add Preference",
  //   "Timeline and Notes",
  //   "Alot Unit",
  //   "Assign Lead",
  //   "Reassign Lead",
  //   "Refund Token",
  //   // "Update Status",
  //   "Share virtual account details"
  // ]);
  const [showDetails, setShowDetails] = useState(false);
  const [style, setStyle] = useState(null);
  const [copyLeadObj, setCopyLeadObj] = useState(leadObj);
  const [leadToken, setLeadToken] = useState([]);
  //modal setState
  const [scheduleSiteVisitModal, setScheduleSiteVisitModal] = useState(false);
  const [timeLineAndNotesModal, setTimeLineAndNotesModal] = useState(false);
  const [assignNewTokenModal, setAssignNewTokenModal] = useState(false);
  const [addPreferenceModal, setAddPreferenceModal] = useState(false);
  const [changeTokenModal, setChangeTokenModal] = useState(false);
  const [addSiteVisitModal, setAddSiteVisitModal] = useState(false);
  const [changeUnitModal, setChangeUnitModal] = useState(false);
  const [cancelUnitModal, setCancelUnitModal] = useState(false);
  const [refundTokenModal, setRefundTokenModal] = useState(false);
  const [refundTokenData, setRefundTokenData] = useState(null);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [reAssignLeadModal, setReAssignLeadModal] = useState(false);
  const [churnLeadModal, setChurnLeadModal] = useState(false);
  const [alotUnitModal, setAlotUnitModal] = useState(false);
  const [viewVirtualAccDetailsModal, setViewVirtualAccDetailsModal] = useState(false)
  const [leadSourceChangeModal, setLeadSourceChangeModal] = useState(false);
  const [viewDetailsLeadRLModal, setViewDetailsLeadRLModal] = useState(false);
  const [assignTitle, setAssignTitle] = useState("Assign Lead");
  const [changeTokenPassData, setChangeTokenPassData] = useState("");
  const [selectedAllotment, setSelectedAllotment] = useState(null);
  const [updateLeadDetailsModal, setUpdateLeadDetailsModal] = useState(null);
  const [virtualAccountStatusModal, setVirtualAccountStatusModal] =
    useState(null);
  const [showCloseVirtualAccModal, setShowCloseVirtualAccModal] =
    useState(false);
  const [closeVirtualAccMsg, setCloseVirtualAccMsg] = useState("");
  const [virtualAccountStatus, setVirtualAccountStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  // until site visit
  const WhatsAppMessage =
    leadObj?.leadtype === "R&L"
      ? `Hello ${leadObj?.leadname},%0a%0aThis is ${leadObj?.salesname} from the VJ Sales Team.%0a${leadObj?.referrername}, your ${leadObj?.referrerrelationshipm}, has referred you for buying a ${leadObj?.project?.unitType} property at ${leadObj?.project?.name} with us.%0a%0aI am here to assist you in your Home Buying Journey with Vilas Javdekar Developers. I will be your dedicated Sales Manager from the VJ One Parivaar Sales Team.%0a%0aCan we get on a call quickly to take this conversation ahead? Kindly let me know.%0a%0aWarm regards,%0a${leadObj?.salesname}%0aSales Manager | VJ One Parivaar`
      : `Hello Mr.${leadObj.leadname}%0a %0a,Greetings from Vilas Javdekar Developers !%0a %0aYour current Status:${leadObj.leadstatus}.%0a %0aCustomer Portal link:${process.env.REACT_APP_CUSTOMER_PORTAL}`

  //more detailsl->
  // allotment
  // token three dots
  // const [tokenSubList, setTokenSubList] = useState([]);
  // console.log(copyLeadObj,copyLeadObj.leadStatus);

  useEffect(() => {
    console.log("111 useefect", leadObj);
    setCopyLeadObj(leadObj)
  }, [leadObj])

  useEffect(() => {
    console.log("BA Name", copyLeadObj?.LeadsReferral?.brandambassador)
    console.log("Mapped BA Name", copyLeadObj?.brandambassador);
  }, [copyLeadObj])

  //   const handleCall = async () => {
  //   console.log("handleCall Running ------- ")
  //   const apiUrl = "https://api-smartflo.tatateleservices.com/v1/click_to_call";
  //   const token = process.env.REACT_APP_TATA_TELE_AUTH_TOKEN; // Store in environment or secure storage

  //   console.log("Token in handleCall ==> ", token)
  //   const requestData = {
  //     async: 1,
  //     // agent_number: "7058233110", // Replace with your agent number (rohit jadhav's number sir for testing)
  //     // destination_number: "7066275321" // Replace with the destination number (pawan chandak's sir number for testing)

  //      agent_number: "8080418310", // Replace with your agent number (rohit jadhav's number sir for testing)
  //     destination_number: "9503296704"
  //   };

  //   try {
  //     const response = await fetch(apiUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Authorization': `Bearer ${token}`,
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify(requestData)
  //     });

  //     if (response.ok) {
  //       const result = await response.json();
  //       console.log("Call initiated successfully:", result);
  //     } else {
  //       const errorData = await response.json();
  //       console.error("Error initiating call:", errorData);
  //     }
  //   } catch (error) {
  //     console.error("Failed to make API request:", error);
  //   }
  // };


  const handleCall = async (e) => {
    e.preventDefault();

    console.log("handleCall Running ------- ");

    const destination_number = copyLeadObj?.leadcontactnumber;

    // ✅ Get agent number from localStorage safely
    let agent_number = null;
    let caller_id = null;

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      console.log("User from localStorage:", user);
      agent_number = user?.contactNumber;
      caller_id = user?.assignedCallerDid;
    } catch (err) {
      console.error("Invalid user data in localStorage");
    }

    // ❗ Guard clause (don’t proceed if missing data)
    if (!agent_number || !destination_number) {
      toast.error("Missing agent or customer number", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    try {
      const result = await makeCall({
        agent_number,
        destination_number,
        caller_id
      });

      if (result?.success) {
        console.log("Call initiated successfully:", result);

        toast.success("Call initiated successfully!", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        console.error("Error initiating call:", result);

        toast.error(result?.message || "Failed to initiate call", {
          position: "top-center",
          autoClose: 3000,
        });
      }

    } catch (error) {
      console.error("Failed to make API request:", error);

      toast.error(
        error?.message || "Something went wrong while initiating call",
        {
          position: "top-right",
          autoClose: 3000,
        }
      );
    }
  };




  function onChangeSelect(e) {
    updateLeadRes(e);
    // console.log(e);
    setCopyLeadObj({ ...copyLeadObj, leadStatus: e });
    defineColorSchema();
  }
  function updateLeadRes(leadStatus) {
    // console.log(copyLeadObj.leadId,leadStatus);
    updateLeadResponse(copyLeadObj.leadId, leadStatus)
      .then((resp) => {
        console.log(resp);
        // getAllLeads();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // const checkVirtualAccountStatus = () => {
  //   let body = {
  //     virtualAccId: copyLeadObj?.virtualaccid,
  //   };
  //   getVirtualAccountStatus(body)
  //     .then((resp) => {
  //       console.log("virtual account status", resp.data);
  //       const status =
  //         resp?.data?.status && resp?.data?.status === "active"
  //           ? "Active"
  //           : "Closed";

  // setVirtualAccount(status);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       errorTost(error);
  //     });
  // };

  const checkStatus = () => {
    let body = {
      virtualAccId: copyLeadObj?.virtualaccid,
    };
    getVirtualAccountStatus(body)
      .then((resp) => {
        console.log("virtual account incheck", resp);
        setVirtualAccountStatus(resp?.data?.status || "inactive");
        setVirtualAccountStatusModal(true);
      })
      .catch((error) => {
        console.error(error);
        errorTost(error);
      });
  };

  function updateLeadVirtualAccountData(
    leadId,
    virtualAccId,
    virtualAccDetails
  ) {
    updateLeadVirtualAccountDetails(leadId, virtualAccId, virtualAccDetails)
      .then((resp) => {
        // console.log("Virtual Account Details updated in DB", resp);
        setCopyLeadObj({ ...copyLeadObj, virtualaccid: virtualAccId });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const recreateAccount = () => {
    let body = {
      virtualAccId: copyLeadObj?.virtualaccid,
      razorpayCustomerId: copyLeadObj?.razorpaycustomerid,
      leadId: copyLeadObj?.leadId,
    };
    presentLoader();
    recreateVirtualAccount(body)
      .then((resp) => {
        // console.log("Response from Recreate virtual account", resp);
        if (resp?.data?.success) {
          dismissLoader();
          updateLeadVirtualAccountData(
            copyLeadObj?.leadId,
            resp?.data?.virtualAccId,
            resp?.data?.virtualAccDetails
          );
          successTost("Virtual account created successfully");
          setVirtualAccountStatusModal(false);
        } else {
          dismissLoader();
          console.log(resp?.data?.message);
          errorTost(resp?.data?.message);
          setVirtualAccountStatusModal(false);
        }
      })
      
      .catch((error) => {
        console.error(error);
        dismissLoader();
        errorTost(error.message);
        setVirtualAccountStatusModal(false);
      });
  };

  function toCalculateValueFromPercent(percentage, bsp) {
    var numVal1 = Number(bsp);
    var numVal2 = Number(percentage) / 100;

    var totalValue = numVal1 * numVal2;

    return Math.ceil(totalValue);
  }
  function defineColorSchema() {
    let obj = {};
    let tempSideMenuArray = [];
    // Lost mode: skip the status-driven action/menu machinery entirely (the only
    // action is Regenerate) and use the LOST chip palette. Returning here also
    // avoids the generic fallthrough that would build a Reassign/Timeline menu.
    if (lostMode) {
      setStyle({ chipColor: "#B42318", chipBackgroundColor: "#FEF3F2", leadStatusColor: "#B42318" });
      setDropdownList([]);
      return;
    }
    if (copyLeadObj.status === "Claimed") {
      obj.chipColor = "#FF4405";
      obj.chipBackgroundColor = "#FFE6D5";
      //is it present in accessTab and is it present in claimed tab
      let dropDownList = [
        "Add Preference",
        "Schedule site visit",
        "Timeline and Notes",
        "Add site visit",
        "Reassign Lead",
        "Churn Lead",
        "Churn and Create Lead",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            tempSideMenuArray.push(el);
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "Site Visit Verified" ||
      copyLeadObj.status === "Site Visit Done" ||
      copyLeadObj.status === "Token Partial Payment Done" ||
      copyLeadObj.status === "Token Refund Requested"
    ) {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
      let dropDownList = [
        "Add Preference",
        "Timeline and Notes",
        "Assign new token",
        "Reassign Lead",
        "Add site visit",
        "Churn and Create Lead",
        "Alot Unit",
        // "Share virtual account details",
        "View virtual account details",
        "Recreate virtual account",
        "Check virtual account status",
        "Create virtual account",
        "Schedule site visit",
        "Lead Source Change",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Site Visit Scheduled") {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
      const dropDownList = [
        "Add Preference",
        "Schedule site visit",
        "Timeline and Notes",
        "Add site visit",
        "Reassign Lead",
        "Churn Lead",
        "Assign new token",
        "Churn and Create Lead",
        "Lead Source Change",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            tempSideMenuArray.push(el);
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Site Visit Pending") {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
      let dropDownList = [
        "Schedule site visit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        "Lead Source Change",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            tempSideMenuArray.push(el);
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "Token Payment Pending" ||
      copyLeadObj.status === "Token Payment Not Done"
    ) {
      obj.chipColor = "#C11574";
      obj.chipBackgroundColor = "#FDF2FA";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        "Assign new token",
        "Alot Unit",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Churn Lead",
        "Churn and Create Lead",
        "Create virtual account",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            // tempSideMenuArray.push(el);
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "Token Payment Complete" ||
      copyLeadObj.status === "Token Refund Request Rejected" ||
      copyLeadObj.status === "Token Payment Pending"
    ) {
      obj.chipColor = "#3538CD";
      obj.chipBackgroundColor = "#EEF4FF";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Assign new token",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        // "Refund Token",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Alot Unit",
        "Token Refund Requested",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Token Refunded") {
      obj.chipColor = "#3538CD";
      obj.chipBackgroundColor = "#EEF4FF";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Assign new token",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        // "Refund Token",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Alot Unit",
        "Token Refund Requested",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Checkpoint One Cleared") {
      obj.chipColor = "#6941C6";
      obj.chipBackgroundColor = "#F4EBFF";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Assign new token",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Alot Unit",
        // "Refund Token",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Checkpoint Two Cleared") {
      obj.chipColor = "#0E7090";
      obj.chipBackgroundColor = "#ECFDFF";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Add Preference",
        "Timeline and Notes",
        "Assign new token",
        "Reassign Lead",
        "Alot Unit",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        // "Refund Token",
      ];
      // console.log({ tabValue });
      dropDownList.forEach((el, index) => {
        // console.log(loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]);
        // console.log(Object.keys(
        //   loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
        // ))
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "Allotment Partial Payment Done" ||
      copyLeadObj.status === "Allotment Refunded" ||
      copyLeadObj.status === "Preselect payment not done"
    ) {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Change unit",
        "Cancel unit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        "Alot Unit",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Assign new token",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Unit On Hold") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Change unit",
        "Cancel unit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        "Alot Unit",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Assign new token",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "Allotment Payment Pending" ||
      copyLeadObj.status === "Payment Pending"
    ) {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
      const dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Add Preference",
        "Timeline and Notes",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Reassign Lead",
        "Assign new token",
        "Alot Unit",
        "Cancel unit",
        "Change unit",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Change Unit Confirmation Pending") {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
      const dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Add Preference",
        "Timeline and Notes",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Reassign Lead",
        "Assign new token",
        "Alot Unit",
        "Cancel unit",
        "Change unit",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "Allotment Payment Complete" ||
      copyLeadObj.status === "Agreement Done" ||
      copyLeadObj.status === "Change Unit Requested" ||
      copyLeadObj.status?.includes("Cancellation Confirmation Pending") ||
      copyLeadObj.status === "Cancellation Done" ||
      copyLeadObj.status === "Cancellation Not Done" ||
      copyLeadObj.status === "Change Unit Confirmation Rejected" ||
      copyLeadObj.status === "Change Unit Confirmed" ||
      copyLeadObj.status === "Cancellation Pending" ||
      copyLeadObj.status === "Change Unit Rejected" ||
      copyLeadObj.status === "Cancel Unit Requested" ||
      copyLeadObj.status === "PreSelect Payment Pending" ||
      copyLeadObj.status === "PreSelect Unit On Hold" ||
      copyLeadObj.status === "Preselect not confirmed" ||
      copyLeadObj.status === "PreSelect Partial Payment Done" ||
      copyLeadObj.status === "PreSelect Price Confirmation Pending" ||
      copyLeadObj.status === "PreSelect Confirmation Pending" ||
      copyLeadObj.status === "PreSelect Confirmation Pending" ||
      copyLeadObj.status === "Unit Change Requested"
    ) {
      obj.chipColor = "#5925DC";
      obj.chipBackgroundColor = "#F4F3FF";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Change unit",
        "Cancel unit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        "Alot Unit",
        "Assign new token",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            // tempSideMenuArray.push(el);
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (
      copyLeadObj.status === "PreSelect Confirmation Pending" ||
      copyLeadObj.status === "PreSelect Price Confirmation Pending"
    ) {
      obj.chipColor = "#C01048";
      obj.chipBackgroundColor = "#FFF1F3";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Alot Unit",
        "Assign new token",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "PreSelect Payment Pending") {
      obj.chipColor = "#6941C6";
      obj.chipBackgroundColor = "#F4EBFF";
      let dropDownList = [
        "Schedule site visit",
        "Add site visit",
        "Add Preference",
        "Timeline and Notes",
        "Reassign Lead",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
        "Alot Unit",
        "Assign new token",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else if (copyLeadObj.status === "Closed") {
      obj.chipColor = "#027A48";
      obj.chipBackgroundColor = "#ECFDF3";
      const dropDownList = [
        "Add Preference",
        "Timeline and Notes",
        // "Share virtual account details",
        "Recreate virtual account",
        "View virtual account details",
        "Check virtual account status",
        "Create virtual account",
      ];
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
        if (copyLeadObj.type === "R&L") {
          tempSideMenuArray.push("View Details");
        }
      });
      if (copyLeadObj.type === "R&L") {
        tempSideMenuArray.push("View Details");
      }
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    } else {
      if (copyLeadObj?.Sales?.userId === "-") {
        let dropdownList = ["Assign Lead", "Timeline and Notes"];
        let tempSideMenuArray = [];
        dropdownList.forEach((el, index) => {
          if (
            Object.keys(
              loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed
            ).includes(el)
          ) {
            if (loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.[el]
              ?.isAccessible) {
              tempSideMenuArray.push(el);
            }
          }
        });

        if (copyLeadObj.type === "R&L") {
          tempSideMenuArray.push("View Details");
        }
        setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
      } else {
        let dropdownList = ["Reassign Lead", "Timeline and Notes"];
        let tempSideMenuArray = [];
        dropdownList.forEach((el, index) => {
          if (
            Object.keys(
              loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed
            ).includes(el)
          ) {
            if (
              loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.[el]
                ?.isAccessible
            ) {
              tempSideMenuArray.push(el);
            }
          }
        });
        if (copyLeadObj.type === "R&L") {
          tempSideMenuArray.push("View Details");
        }
        setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
      }

      obj.chipBackgroundColor = "#ececec";

      // setDropdownList(["Assign Lead", "Timeline and Notes"]);
    }

    if (tabValue === "Token" || tabValue === "Allotment") {
      const dropDownList = [...dropdownList];
      if (leadObj?.virtualaccid !== null) {
        dropDownList.push("Close virtual account");
      }
      if (!dropDownList.includes("Lead Source Change")) {
        dropDownList.push("Lead Source Change");
      }
      dropDownList.forEach((el, index) => {
        if (
          Object.keys(
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]
          ).includes(el)
        ) {
          if (
            loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]
              ?.isAccessible
          ) {
            if (
              el === "Lead Source Change" &&
              tabValue === "Allotment" &&
              copyLeadObj.leadtype === "R&L"
            ) {
              // skip — R&L leads don't get Lead Source Change on the Allotment tab
            } else if (el === "Create virtual account") {
              if (copyLeadObj.razorpaycustomerid === null) {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Recreate virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "closed") {
                tempSideMenuArray.push(el);

              }
            }
            // else if (el === "Share virtual account details") {
            //   if (copyLeadObj.razorpaycustomerid !== null ) {
            //     tempSideMenuArray.push(el);
            //   }
            // }

            else if (el === "View virtual account details") {
              if (copyLeadObj.razorpaycustomerid !== null && copyLeadObj.virtual_acc_status === "active") {
                tempSideMenuArray.push(el);
              }
            }
            else if (el === "Check virtual account status") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            }

            else if (el === "Close virtual account") {
              if (copyLeadObj.razorpaycustomerid !== null) {
                tempSideMenuArray.push(el);
              }
            } else {
              tempSideMenuArray.push(el);
            }
          }
        }
      });
      setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
    }

    if (tabValue === "Agreement Done") {
      if (
        !tempSideMenuArray.includes("Lead Source Change") &&
        Object.keys(loggedInUser?.roleId?.accessibleTabs?.Leads?.["Agreement Done"] || {}).includes("Lead Source Change") &&
        loggedInUser?.roleId?.accessibleTabs?.Leads?.["Agreement Done"]?.["Lead Source Change"]?.isAccessible
      ) {
        tempSideMenuArray.push("Lead Source Change");
        setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
      }
    }

    if (tabValue === "All") {
      if (
        !tempSideMenuArray.includes("Lead Source Change") &&
        Object.keys(loggedInUser?.roleId?.accessibleTabs?.Leads?.["All"] || {}).includes("Lead Source Change") &&
        loggedInUser?.roleId?.accessibleTabs?.Leads?.["All"]?.["Lead Source Change"]?.isAccessible
      ) {
        tempSideMenuArray.push("Lead Source Change");
        setDropdownList(filterLeadSourceChangeForRnl([...tempSideMenuArray], copyLeadObj.leadtype));
      }
    }

    if (copyLeadObj.leadStatus === "HOT") {
      obj.leadStatusColor = "#B42318";
    } else if (copyLeadObj.leadStatus === "COLD") {
      obj.leadStatusColor = "#175CD3";
    } else if (copyLeadObj.leadStatus === "WARM") {
      obj.leadStatusColor = "#F79009";
    } else {
      obj.leadStatusColor = "#667085";
    }
    if (copyLeadObj.unit?.status === "On Hold") {
      obj.unitChipColor = "#E62E05";
      obj.unitChipBackgroundColor = "#FFF4ED";
    } else if (copyLeadObj.unit?.status === "Done") {
      obj.unitChipColor = "#027A48";
      obj.unitChipBackgroundColor = "#ECFDF3";
    }
    // ! set allotment dropdown list
    // const allotmentDropdownList = []
    // if (loggedInUser.roleId.level === 1 || loggedInUser.roleId.accessibleTabs['All Allotments']['Change Unit Approver']) {
    //   allotmentDropdownList.push('Change unit')
    // } else if (loggedInUser.roleId.level === 1 || loggedInUser.roleId.accessibleTabs['Leads']['Allotment']['Cancel unit'] || loggedInUser.roleId.accessibleTabs['Leads']['All']['Cancel unit']) {
    //   allotmentDropdownList.push('Cancel unit')
    // } else {
    //   allotmentDropdownList.push('No actions available');
    // }
    // console.log('allotmentDropdownList: ', allotmentDropdownList);
    // setAllotmentDropdownList(allotmentDropdownList);
    setStyle(obj);
  }
  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
  }

  // ??sending mail
  async function sendMailAndSms(email, subject) {
    let message = `<h4>Hi ${copyLeadObj?.leadname},</h4>
    <p>Your virtual account details for VJ Developers is:</p></br>
    <p>Razorpay Customer Id:${copyLeadObj?.razorpaycustomerid}</b></p></br>
    <p>Bank Beneficiary Name:${copyLeadObj?.bankbeneficiaryname}</b></p></br>
    <p>Bank Account Number:${copyLeadObj?.bankaccountnumber}</b></p></br>
    <p>Bank IFSCCode:${copyLeadObj?.bankifsccode}</b></p>`;
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    let messageBody = {
      number: `+${copyLeadObj?.leadcontactnumber}`,
      message: `Hi ${copyLeadObj?.leadname},Your virtual account details for VJ Developers is:Razorpay Customer Id: ${copyLeadObj?.razorpaycustomerid},Bank Beneficiary Name: ${copyLeadObj?.bankbeneficiaryname},Bank Account Number: ${copyLeadObj?.bankaccountnumber},Bank IFSCCode: ${copyLeadObj?.bankifsccode}`,
      is_international_number:
        copyLeadObj?.leadcontactnumber.toString().substring(0, 2) !== "91"
          ? true
          : false,
    };
    const sms = await sendMessage(messageBody)
      .then((resp) => {
        if (resp.data.success) {
          return true;
        } else {
          if (resp?.data?.error) {
            return false;
          }
        }
      })
      .catch((err) => {
        return false;
      });
    const emailRes = await sendMailTo(body)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return { emailRes, sms };
  }
  async function sendMailAndSmsForTokenPaymentLink(email, subject, tokenName) {
    let message = `<h4>Hi ${copyLeadObj?.leadname},</h4>
    <p>${tokenName} has been assigned to you successfully.Please login ${process.env.REACT_APP_CUSTOMER_PORTAL} to complete token payment.</p></br>
    `;
    let body = {
      to: [email],
      subject: subject,
      message: message,
    };
    let messageBody = {
      number: `+${copyLeadObj?.leadcontactnumber}`,
      message: `Hi ${copyLeadObj?.leadname},${tokenName} has been assigned to you successfully.Please login ${process.env.REACT_APP_CUSTOMER_PORTAL} to complete token payment`,
      is_international_number:
        copyLeadObj?.leadcontactnumber.toString().substring(0, 2) !== "91"
          ? true
          : false,
    };
    const sms = await sendMessage(messageBody)
      .then((resp) => {
        if (resp.data.success) {
          return true;
        } else {
          if (resp?.data?.error) {
            return false;
          }
        }
      })
      .catch((err) => {
        return false;
      });
    const emailRes = await sendMailTo(body)
      .then((resp) => {
        console.log(resp);
        if (resp.data.status === "err") {
          return false;
        } else {
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
        return false;
      });
    return { emailRes, sms };
  }
  function shareVirtualAccDetails() {
    sendMailAndSms(`${copyLeadObj?.leademail}`, "Virtual Account Details").then(
      (resp) => {
        console.log(resp);
        if (resp.emailRes && resp.sms) {
          successTost("Email and sms sent successfully");
        } else if (resp.emailRes === false && resp.sms) {
          errorTost("Sms sent successfully,error while sending email ");
        } else if (resp.emailRes && resp.sms === false) {
          errorTost("Email sent successfully,error while sending sms ");
        } else {
          errorTost("Error while sending Email and Sms");
        }
      }
    );
  }
  function createVirtualAccountFun() {
    let body = {
      name: leadObj.leadname,
      contactNumber: `+${leadObj.leadcontactnumber}`,
      email: leadObj.leademail,
      leadId: leadObj.leadId,
    };
    presentLoader();
    createVirtualAccount(body)
      .then((resp) => {
        console.log("create Virtual account resp", resp);
        if (resp?.data?.success) {
          dismissLoader();
          returnResLeads(true);
          successTost("Virtual account created successfully");
        } else {
          dismissLoader();
          if (resp?.data?.errorMsg.includes('Virtual Account already Exists')) {
            // ??open modal 
            setUpdateLeadDetailsModal(true);
          } else {
            errorTost(resp?.data?.errorMsg);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        dismissLoader();
        errorTost(err.message);
      });
  }

  function getVirtualAcountStatus() {
    let body = {
      virtualAccId: leadObj?.virtualaccid,
    };
    presentLoader();
    getVirtualAccountStatus(body)
      .then((resp) => {
        dismissLoader();
        if (resp?.data?.status !== "inactive") {
          setCloseVirtualAccMsg(
            `Are you sure do you want close virtual account for lead ${leadObj?.leadname}?`
          );
        } else {
          setCloseVirtualAccMsg(
            `${leadObj?.leadname} virtual account already closed !`
          );
        }
        setShowCloseVirtualAccModal(true);
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  }

  function closeVirtualAccountFun() {
    let body = {
      virtualAccId: leadObj?.virtualaccid,
      leadId: leadObj.leadId,
    };
    presentLoader();
    closeVirtualAccount(body)
      .then((resp) => {
        if (resp?.data?.success) {
          dismissLoader();
          returnResLeads(true);
          successTost("Virtual account closed successfully");
        } else {
          dismissLoader();
          errorTost(resp?.data?.error?.message);
        }
        setShowCloseVirtualAccModal(false);
      })
      .catch((err) => {
        console.log(err);
        setShowCloseVirtualAccModal(false);
        dismissLoader();
        errorTost(err?.response?.data?.message);
      });
  }

  useEffect(() => {
    defineColorSchema();
  }, [copyLeadObj.leadStatus]);
  // useEffect(() => {
  //   console.log(copyLeadObj);
  // }, [copyLeadObj]);
  // ??All alloted Allotments
  function getLeadAlotedProject() {
    getAllotedData(copyLeadObj.leadId)
      .then((resp) => {
        console.log(resp);
        resp.data = resp.data.map((each) => ({
          ...each,
          WhatsAppMessage:
            each.status === "Payment Complete" && each.kycFormFilled
              ? `Hello Mr.${leadObj.leadname
              },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${each?.unitId?.projectId?.projectName
                ? each?.unitId?.projectId?.projectName
                : each?.inventoryMergedId?.projectId?.projectName
              }.%0a Your Allotment payment status:${each.status
              }.%0aCustomer Portal link:${process.env.REACT_APP_CUSTOMER_PORTAL
              }.%0a %0aRegards,Team VJ`
              : each.status === "Payment Complete" && !each.kycFormFilled
                ? `Hello Mr.${leadObj.leadname
                },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${each?.unitId?.projectId?.projectName
                  ? each?.unitId?.projectId?.projectName
                  : each?.inventoryMergedId?.projectId?.projectName
                }.%0aYour Allotment payment status:${each.status
                }.%0aPlease complete your kyc through Customer Portal link:${process.env.REACT_APP_CUSTOMER_PORTAL
                }.%0a %0aRegards,Team VJ`
                : each.status === "Partial Payment Done" && !each.kycFormFilled
                  ? `Hello Mr.${leadObj.leadname
                  },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour selection ${each?.unitId?.projectId?.projectName
                    ? each?.unitId?.projectId?.projectName
                    : each?.inventoryMergedId?.projectId?.projectName
                  }.%0aYour Allotment payment status:${each.status
                  }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed.${process.env.REACT_APP_CUSTOMER_PORTAL
                  }.%0a %0aRegards,Team VJ`
                  : each.status === "Partial Payment Done" && each.kycFormFilled
                    ? `Hello Mr.${leadObj.leadname
                    },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${leadObj.leadstatus
                    }.%0aYour Allotment payment status:${each.status
                    }.%0aYour selection ${each?.unitId?.projectId?.projectName
                      ? each?.unitId?.projectId?.projectName
                      : each?.inventoryMergedId?.projectId?.projectName
                    }.%0aPlease complete your payment through:${process.env.REACT_APP_CUSTOMER_PORTAL
                    }.%0a %0aRegards,Team VJ`
                    : each.status === "Payment Pending"
                      ? `Hello Mr.${leadObj.leadname
                      },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${leadObj.leadstatus
                      }.%0aYour Allotment payment status:${each.status
                      }.%0aYour selection ${each?.unitId?.projectId?.projectName
                        ? each?.unitId?.projectId?.projectName
                        : each?.inventoryMergedId?.projectId?.projectName
                      }%0aPlease Confirm your booking by paying through the link below:%0a${process.env.REACT_APP_CUSTOMER_PORTAL
                      }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`
                      : `Hello Mr.${leadObj.leadname
                      },%0a %0aGreetings from Vilas Javdekar Developers !%0a %0aYour current Status:${leadObj.leadstatus
                      }.%0aYour Allotment payment status:${each.status
                      }.Your selection ${each?.unitId?.projectId?.projectName
                        ? each?.unitId?.projectId?.projectName
                        : each?.inventoryMergedId?.projectId?.projectName
                      }%0aPlease Confirm your booking by paying through the link below:%0a:${process.env.REACT_APP_CUSTOMER_PORTAL
                      }.%0aYou will recieve a confirmation email with more information after the payment has been processed and the booking details form has been completed. %0aRegards,Team VJ`,
        }));
        let allotmentData = resp.data;
        // if (loggedInUser.roleId.level === 1 || loggedInUser.roleId.accessibleTabs['All Allotments']['Change Unit Approver']) {
        //   allotmentDropdownList.push('Change unit')
        // } else if (loggedInUser.roleId.level === 1 || loggedInUser.roleId.accessibleTabs['Leads']['Allotment']['Cancel unit'] || loggedInUser.roleId.accessibleTabs['Leads']['All']['Cancel unit']) {
        //   allotmentDropdownList.push('Cancel unit')
        // } else {
        //   allotmentDropdownList.push('No actions available');
        // }
        allotmentData = allotmentData.map((el) => ({ ...el, subMenu: [], farvisionCancelled: el.CancelUnitRequests.find((ele) => { return ele.cancelledInFarvision === true }) }));

        allotmentData.forEach((el) => {
          if (el.status !== 'Cancellation Requested' && el.status !== "Released" && el.status !== "Cancelled" && !el.status?.includes('Refund')) {
            if (
              (
                (loggedInUser.roleId.level === 1 ||
                  loggedInUser.roleId.accessibleTabs["All Allotments"]["Change Unit Approver"]) &&
                (loggedInUser.roleId.accessibleTabs["Leads"]["Allotment"]["Change unit"] ||
                  loggedInUser.roleId.accessibleTabs["Leads"]["All"]["Change unit"]))
              && (el?.CRM?.length === 0 || el?.CRM === null)
            ) {
              el.subMenu.push("Change unit");
            }

            if (
              loggedInUser.roleId.level === 1 ||
              loggedInUser.roleId.accessibleTabs["Leads"]["Allotment"]["Cancel unit"] ||
              loggedInUser.roleId.accessibleTabs["Leads"]["All"]["Cancel unit"] && (el.bookingId === null && el.CRM?.isApproved === false)
            ) {
              if (el.CancelUnitRequests.length > 0) {
                console.log("el", el)
                if (!el.farvisionCancelled?.cancelledInFarvision) {
                  el.subMenu.push("Cancel unit");
                }
              } else {
                el.subMenu.push("Cancel unit");
              }

            }
            if (el.subMenu.length === 0) {
              el.subMenu = ["No Actions Available"];
            }
          } else {
            el.subMenu = ["No Actions Available"];
          }
        });
        console.log({ allotmentData });
        setCopyLeadObj((pre) => {
          return { ...pre, allotmentData };
        });
        console.log(copyLeadObj);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getLeadAssignedToken() {
    if (CardType !== "TokenHolders") {
      getAssignedToken(copyLeadObj.leadId)
        .then((resp) => {
          let leadTokens = resp;
          leadTokens.forEach((el) => {
            let date = new Date(el.created_at);
            let tokenExpire = date.setDate(date.getDate() + el.eventTokenId.tokenId.validity);
            let validUpto = new Date(tokenExpire);
            validUpto = new Date(tokenExpire);
            el.expirationDate = validUpto > Date.now() ? validUpto : "expired";
          });
          leadTokens = leadTokens.map((el, index) => ({
            ...el,
            id: index,
            tokenName: el.eventTokenId.tokenId.name,
            tokenType: el.eventTokenId.tokenId.inventoryTypeId.type,
            validity: el.eventTokenId.tokenId.validity,
            refundable: el.eventTokenId.tokenId.isRefundable ? "YES" : "NO",
            eventName: el.eventId.title,
            tokenSubList: [],
            WhatsAppMessage:
              el.status === "pending"
                ? `Hello Mr.${leadObj.leadname},%0a %0a Thank you for choosing  VJ!%0a %0aYour token status:${el.status}.%0aClick this link to complete your purchase:${process.env.REACT_APP_CUSTOMER_PORTAL}.%0a %0aOnce the payment is processed,we will send an email confirmation on your registered email-id with further details.%0aWe hope for you to become a part of our VJ Parivaar soon. %0aRegards,Team VJ`
                : el.status === "partial"
                  ? `Hello Mr.${leadObj.leadname},%0a %0a Thank you for choosing  VJ!%0a %0aYour token status:${el.status}.%0aClick this link to complete your purchase:${process.env.REACT_APP_CUSTOMER_PORTAL}.%0a %0a Once the payment is processed,we will send an email confirmation on your registered email-id with further details.%0aWe hope for you to become a part of our VJ Parivaar soon. %0aRegards,Team VJ`
                  : `Hello Mr.${leadObj.leadname},%0a %0a Thank you for choosing  VJ!%0a %0aYour token status:${el.status}.%0a %0aRegards,Team VJ`,
          }));
          console.log("leadTokens", leadTokens);
          setLeadToken([...leadTokens]);
          leadTokens.forEach((el) => {
            // console.log(el.eventTokenId.tokenId.isRefundable);
            if (el.expirationDate !== "expired") {
              // console.log(el.status === "alloted", !el.eventId.adjustTokenAmt)
              // ! check if token is priority pass; if yes, no actions available
              if (!el.isPrerequisiteUsed) {
                if (
                  el.eventTokenId.tokenId.isRefundable &&
                  loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.["Refund Token"]?.isAccessible
                ) {
                  if (el.status === "pending") {
                    el.tokenSubList.push("Share Payment Link");
                  }
                  // ! commented as per trello card client request
                  // ! Change as per task for refund Request Raise
                  else if (
                    (el.status === "active" ||
                      // (el.status === "alloted" && !el.eventId.adjustTokenAmt))&&     // ! as discussed then, if token is adjustable in allotment; do not refund
                      el.status === "alloted") &&
                    !el.eventTokenId.tokenId.isPreselect
                  ) {
                    el.tokenSubList.push("Refund Token");
                  } else {
                    el.tokenSubList.push("No actions available");
                  }
                } else {
                  if (el.status === "pending") {
                    el.tokenSubList.push("Share Payment Link");
                  }
                }
                if (
                  loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[
                    "Change Token"
                  ]?.isAccessible
                ) {
                  if (el.status === "active" || el.status === "partial") {
                    el.tokenSubList.push("Change Token");
                  }
                }
              } else {
                el.tokenSubList.push("No actions available");
                // el.status = "Upgraded";
              }
            }
            if (el.tokenSubList.length === 0) {
              el.tokenSubList.push("No actions available");
            }
          });
          // setCopyLeadObj((pre) => {
          //   return { ...pre, leadTokens };
          // });
          console.log({ copyLeadObj });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      getAssignedTokenForHolders(copyLeadObj.leadId, copyLeadObj.tokennumber).then((holdersResp) => {
        console.log("holdersResp", holdersResp)
        let leadTokens = holdersResp;
        leadTokens.forEach((el) => {
          let date = new Date(el.created_at);
          let tokenExpire = date.setDate(date.getDate() + el.eventTokenId.tokenId.validity);
          let validUpto = new Date(tokenExpire);
          validUpto = new Date(tokenExpire);
          el.expirationDate = validUpto > Date.now() ? validUpto : "expired";
        });
        leadTokens = leadTokens.map((el, index) => ({
          ...el,
          id: index,
          tokenName: el.eventTokenId.tokenId.name,
          tokenType: el.eventTokenId.tokenId.inventoryTypeId.type,
          validity: el.eventTokenId.tokenId.validity,
          refundable: el.eventTokenId.tokenId.isRefundable ? "YES" : "NO",
          eventName: el.eventId.title,
          tokenSubList: [],
          WhatsAppMessage:
            el.status === "pending"
              ? `Hello Mr.${leadObj.leadname},%0a %0a Thank you for choosing  VJ!%0a %0aYour token status:${el.status}.%0aClick this link to complete your purchase:${process.env.REACT_APP_CUSTOMER_PORTAL}.%0a %0aOnce the payment is processed,we will send an email confirmation on your registered email-id with further details.%0aWe hope for you to become a part of our VJ Parivaar soon. %0aRegards,Team VJ`
              : el.status === "partial"
                ? `Hello Mr.${leadObj.leadname},%0a %0a Thank you for choosing  VJ!%0a %0aYour token status:${el.status}.%0aClick this link to complete your purchase:${process.env.REACT_APP_CUSTOMER_PORTAL}.%0a %0a Once the payment is processed,we will send an email confirmation on your registered email-id with further details.%0aWe hope for you to become a part of our VJ Parivaar soon. %0aRegards,Team VJ`
                : `Hello Mr.${leadObj.leadname},%0a %0a Thank you for choosing  VJ!%0a %0aYour token status:${el.status}.%0a %0aRegards,Team VJ`,
        }));
        console.log("leadTokens", leadTokens);
        setLeadToken([...leadTokens]);
        leadTokens.forEach((el) => {
          // console.log(el.eventTokenId.tokenId.isRefundable);
          if (el.expirationDate !== "expired") {
            // console.log(el.status === "alloted", !el.eventId.adjustTokenAmt)
            // ! check if token is priority pass; if yes, no actions available
            if (!el.isPrerequisiteUsed) {
              if (
                el.eventTokenId.tokenId.isRefundable &&
                loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.["Refund Token"]?.isAccessible
              ) {
                if (el.status === "pending") {
                  el.tokenSubList.push("Share Payment Link");
                }
                // ! commented as per trello card client request
                // ! Change as per task for refund Request Raise
                else if (
                  (el.status === "active" ||
                    // (el.status === "alloted" && !el.eventId.adjustTokenAmt))&&     // ! as discussed then, if token is adjustable in allotment; do not refund
                    el.status === "alloted") &&
                  !el.eventTokenId.tokenId.isPreselect
                ) {
                  el.tokenSubList.push("Refund Token");
                } else {
                  el.tokenSubList.push("No actions available");
                }
              } else {
                if (el.status === "pending") {
                  el.tokenSubList.push("Share Payment Link");
                }
              }
              if (
                loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[
                  "Change Token"
                ]?.isAccessible
              ) {
                if (el.status === "active" || el.status === "partial") {
                  el.tokenSubList.push("Change Token");
                }
              }
            } else {
              el.tokenSubList.push("No actions available");
              // el.status = "Upgraded";
            }
          }
          if (el.tokenSubList.length === 0) {
            el.tokenSubList.push("No actions available");
          }
        });
      });
    }
  }
  //Token Columns
  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        return (
          <>
            <ThreeDotsMenu
              list={params.row.tokenSubList}
              selectedValue={(e) => {
                console.log(e);
                console.log(params.row);
                if (e === "Share Payment Link") {
                  sendMailAndSmsForTokenPaymentLink(
                    `${copyLeadObj?.leademail}`,
                    "Token has been assigned successfully",
                    params.row.tokenName
                  ).then((resp) => {
                    console.log(resp);
                    if (resp.emailRes && resp.sms) {
                      successTost("Email and sms sent successfully");
                    } else if (resp.emailRes === false && resp.sms) {
                      errorTost(
                        "Sms sent successfully,error while sending email "
                      );
                    } else if (resp.emailRes && resp.sms === false) {
                      errorTost(
                        "Email sent successfully,error while sending sms "
                      );
                    } else {
                      errorTost("Error while sending Email and Sms");
                    }
                  });
                  // checkForPaymentDone(
                  //   params.row.leadId,
                  //   params.row.paymentId,
                  //   params.row
                  // );
                } else if (e === "Refund Token") {
                  if (params.row.TokenRefundRequests?.length === 0) {
                    setRefundTokenModal(true);
                    setRefundTokenData(params.row);
                  } else {
                    const refundData = params.row.TokenRefundRequests.find((item) => item.status === "pending")
                    if (refundData) {
                      successTost("This token is already in request process.");
                    } else {
                      setRefundTokenModal(true);
                      setRefundTokenData(params.row);
                    }
                  }
                } else if (e === "Change Token") {
                  setChangeTokenPassData(params.row);
                  setChangeTokenModal(true);
                }
              }}
            />
            <a
              style={{ marginRight: "2rem" }}
              href={`https://wa.me/${leadObj.leadcontactnumber}/?text=${params.row.WhatsAppMessage}`}
              data-action="share/whatsapp/share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsappIcon size={32} round={true} />
            </a>
          </>
        );
      },
    },
    {
      field: "tokenName",
      headerName: "Token Name",
      width: 250,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status !== "pending" &&
              params.row.status !== "partial" && (
                <p className={cssClasses.tokenNumber}>
                  VJ{params.row.tokenNumber}
                </p>
              )}
            <p className={cssClasses.tokenName}>{params.row.tokenName}</p>
          </div>
        );
      },
    },

    {
      field: "tokenType",
      headerName: "Token Type",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {params.row.eventTokenId.tokenId.isPreselect ?
              <div>Preselect</div>
              :
              params.row.eventTokenId.tokenId.isPriorityPass ?
                <div>Priority Pass</div> :
                <div>Global Token</div>
            }
            <div></div>
            <div>{params.row.tokenType}</div>
          </div>
        )
      }
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (params) => {
        return (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem'
          }}>
            {params.row.status === "pending" && (
              <LeadStatusChip
                style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.status === "active"
              && !params.row.isPrerequisiteUsed &&
              (
                <LeadStatusChip
                  style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
                  label={params.row.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
            {params.row.status === "alloted" && (
              <LeadStatusChip
                style={{ color: "#C01048", backgroundColor: "#FFF1F3" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {(params.row.status === "refund requested" ||
              params.row.status === "refund initiated") && (
                <LeadStatusChip
                  style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                  label={params.row.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />

              )}
            {params.row.isPrerequisiteUsed && params.row.status === "active" && (
              <LeadStatusChip
                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                label={'Upgraded'}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {(params.row.status === "refunded" ||
              params.row.status === "refund processed") && (
                <LeadStatusChip
                  style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
                  label={params.row.status}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                />
              )}
            {params.row.status === "expired" && (
              <LeadStatusChip
                style={{ color: "#B54708", backgroundColor: "#FFF4ED" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.status === "partial" && (
              <LeadStatusChip
                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.status === "refund rejected" && (
              <LeadStatusChip
                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
            {params.row.status === "adjusted" && (
              <LeadStatusChip
                style={{ color: "#5925DC", backgroundColor: "#F4F3FF" }}
                label={params.row.status}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
              />
            )}
          </div>
        );
      },
    },
    {
      field: "Action",
      headerName: "Valid Upto",
      // type: 'number',
      width: 250,
      renderCell: (params) => {
        let date = new Date(params.row.created_at);
        let tokenExpire = date.setDate(date.getDate() + params.row.validity);
        let validUpto = new Date(tokenExpire);
        return (
          <div>
            {validUpto > Date.now() &&
              params.row.status !== "expired" &&
              params.row.status !== "refund processed" &&
              params.row.status !== "refund initiated" &&
              (
                <div>
                  {validUpto.toDateString()},
                  {new Date(validUpto).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>)}
            {validUpto < Date.now() && params.row.status === "alloted" && (
              <div>
                {validUpto.toDateString()},
                {new Date(validUpto).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            )}
            {validUpto < Date.now() && params.row.status !== "alloted" && (
              <LeadStatusChip
                style={{
                  color: "#FF4405",
                  backgroundColor: "#FFE6D5",
                }}
                label={"Expired"}
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            )}
            {validUpto > Date.now() && (params.row.status === "expired" || params.row.status === "refund processed" ||
              params.row.status === "refund initiated") && (
                <LeadStatusChip
                  style={{
                    color: "#FF4405",
                    backgroundColor: "#FFE6D5",
                  }}
                  label={"Expired"}
                  icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                />
              )}
          </div>
        );
      },
    },
    {
      field: "refundable",
      headerName: "Refundable",
      width: 150,
    },
    {
      field: "eventName",
      headerName: "Event Name",
      width: 250,
    },
    {
      field: "paidAmount",
      headerName: "Amount Paid",
      width: 170,
      renderCell: (params) => {
        return (
          <div>
            <p className={cssClasses.tokenNumber}>
              ₹{numberWithCommas(params.row.paidAmount)}
            </p>
          </div>
        );
      },
    },
    {
      field: "amount",
      headerName: "Token Amount",
      width: 170,
      renderCell: (params) => {
        return (
          <div>
            <p className={cssClasses.tokenNumber}>
              ₹{numberWithCommas(params.row.amount)}
            </p>
          </div>
        );
      },
    },
    {
      field: "tokenCompletionDate",
      headerName: "Token Completion Date",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            <p className={cssClasses.tokenNumber}>
              {params.row.paymentCompleteDate && (
                <>
                  {new Date(params.row.paymentCompleteDate).toDateString()},{" "}
                  {new Date(params.row.paymentCompleteDate).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </>
              )}
            </p>
          </div>
        );
      },
    },
  ];
  // !!Flow changed now
  // function checkForPaymentDone(leadId, paymentId, data) {
  //   checkPaymentStatus(leadId, paymentId)
  //     .then((resp) => {
  //       console.log(resp);
  //       if (resp.length > 0) {
  //         if (resp[0]?.status === "complete") {
  //           successTost(
  //             "Payment has been done.Please wait for a while, payment status will reflect soon"
  //           );
  //         } else if (
  //           resp[0]?.status === "pending" &&
  //           resp[0]?.paymentLinkId !== ""
  //         ) {
  //           resendPaymentLink({ paymentId: resp[0].paymentLinkId })
  //             .then((resp) => {
  //               if (resp.success) {
  //                 successTost("Payment Link send successfully");
  //               } else {
  //                 errorTost(resp.message);
  //               }
  //               console.log(resp);
  //             })
  //             .catch((err) => {
  //               console.log(err);
  //             });
  //         } else {
  //           let body = {
  //             leadName: copyLeadObj?.leadname,
  //             leadEmail: copyLeadObj?.leademail,
  //             leadContactNumber: copyLeadObj?.leadcontactnumber,
  //             leadId: data?.leadId,
  //             eventTokenId: data?.eventTokenId?.eventTokenId,
  //             eventName: data?.eventId?.title,
  //             amount: data?.eventTokenId?.tokenId?.amount,
  //             tokenName: data?.tokenName,
  //             paymentId: data.paymentId,
  //             mode: "token",
  //           };
  //           createPaymentLink(body)
  //             .then((resp) => {
  //               if (resp.success) {
  //                 successTost("Payment Link send successfully");
  //               } else {
  //                 errorTost(resp.message);
  //               }
  //               console.log(resp);
  //             })
  //             .catch((err) => {
  //               console.log(err);
  //               dismissLoader();
  //             });
  //         }
  //       } else {
  //         let body = {
  //           leadName: copyLeadObj?.leadname,
  //           leadEmail: copyLeadObj?.leademail,
  //           leadContactNumber: copyLeadObj?.leadcontactnumber,
  //           leadId: data?.leadId,
  //           eventTokenId: data?.eventTokenId?.eventTokenId,
  //           eventName: data?.eventId?.title,
  //           amount: data?.eventTokenId?.tokenId?.amount,
  //           tokenName: data?.tokenName,
  //           paymentId: data.paymentId,
  //           mode: "token",
  //         };
  //         createPaymentLink(body)
  //           .then((resp) => {
  //             if (resp.success) {
  //               successTost("Payment Link send successfully");
  //             } else {
  //               errorTost(resp.message);
  //             }
  //             console.log(resp);
  //           })
  //           .catch((err) => {
  //             console.log(err);
  //             dismissLoader();
  //           });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }
  function returnRes(value) {
    if (value) {
      returnResLeads(true);
      setCancelUnitModal(false);
    }
  }
  // console.log("Lead Obj in card:", leadObj);
  console.log("Copy Lead Obj in card:", copyLeadObj);
  // console.log("copyLeadObj Referral", copyLeadObj.referral);


  const uploadLeadToContactGroup = async (leadId) => {
    try {
      if (!leadId) {
        throw new Error("leadId is required");
      }

      const baseUrl = process.env.REACT_APP_PAYMENT_LINK_URL?.replace(/\/$/, "");

      const res = await axios.post(
        `${baseUrl}/api/smartflo/upload-lead-to-contactgroup`,
        { id: leadId },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("✅ Upload success:", res.data);
      return res.data;

    } catch (err) {
      console.error(
        "❌ Upload failed:",
        err.response?.data || err.message
      );
      throw err;
    }
  };


  const handleClaimAndUpload = async () => {
    setLoading(true);
    try {
      await claimLead();
      console.log("Lead claimed successfully, now uploading to contact group...",copyLeadObj.leadId);
      await uploadLeadToContactGroup(copyLeadObj.leadId);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      variant="outlined"
      sx={[
        {
          boxShadow:
            "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
          borderRadius: "0.8rem ",
        },
      ]}
    >
      <div className={cssClasses.container}>
        <div className={cssClasses.header}>
          {/* {copyLeadObj.status !== "Unclaimed"&&( */}
          <div className={cssClasses.headerDiv1}>
            {selectMultipleLeads && <div className={cssClasses.rowWrapper}>
              <input style={{ height: "2rem", width: "2rem" }} type="checkbox" name="" id="" onChange={onSelecting} checked={copyLeadObj.isSelected} />
            </div>}
            {/* Lead-quality is not editable for a Lost lead — hide the dropdown. */}
            {!lostMode && (
              <div style={{ flex: "0.5" }}>
                <Dropdown
                  list={leadTypeList}
                  style={{
                    background: "#FFF",
                    selectedColor: style?.leadStatusColor,
                  }}
                  selectedValue={copyLeadObj.leadStatus ?? "WARM"}
                  onChangeSelect={onChangeSelect}
                />
              </div>
            )}
            <div>
              <div className={cssClasses.rowWrapper}>
                <div className={cssClasses.label}>
                  <p>Type Of Lead</p>
                </div>
                <div className={cssClasses.label}>
                  <p>:</p>
                </div>
                <div className={cssClasses.value}>
                  <p>{copyLeadObj.type}</p>
                </div>
              </div>
            </div>
            <div style={{ padding: "1rem 0.5rem 1rem 1rem" }}>
              <LeadStatusChip
                style={{
                  color: style?.chipColor,
                  backgroundColor: style?.chipBackgroundColor,
                }}
                label={copyLeadObj.status}
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            </div>

            {/* Site-visit verification badge (from leadsfilter_matchmaking.verificationstatus):
                Verified / Rejected / Verification Pending. */}
            {(() => {
              const vb = getVerificationBadge(copyLeadObj?.verificationstatus);
              return (
                <div style={{ flex: "1", padding: "1rem 1rem 1rem 0" }}>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.6rem",
                      padding: "0.3rem 1.2rem",
                      borderRadius: "1.6rem",
                      fontSize: "1.3rem",
                      fontFamily: "Inter-Medium",
                      whiteSpace: "nowrap",
                      backgroundColor: vb.bg,
                      color: vb.color,
                      border: `1px solid ${vb.border}`,
                    }}
                  >
                    <span
                      style={{
                        width: "0.7rem",
                        height: "0.7rem",
                        borderRadius: "50%",
                        backgroundColor: vb.dot,
                      }}
                    />
                    {vb.label}
                  </div>
                </div>
              );
            })()}

          </div>
          {/* )} */}

          <div className={cssClasses.headerDiv2}>
            <div>
              {CardType === "TokenHolders" ? (
                <ReactTimeAgo
                  style={{ fontSize: "1.2rem" }}
                  date={copyLeadObj?.last_updated_at ?? copyLeadObj?.createdAt}
                  locale="en-US"
                />
              ) : (
                <ReactTimeAgo
                  style={{ fontSize: "1.2rem" }}
                  date={copyLeadObj?.last_updated_at ?? copyLeadObj?.createdAt}
                  locale="en-US"
                  claimLead
                />
              )}
            </div>
            {(() => {
              const bucket = getScoreBucket(copyLeadObj?.leadfinalscore);
              if (!bucket) return null;
              return (
                <Tooltip
                  title={`Your match score for this lead — based on your persona (${bucket.label} match)`}
                  arrow
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "0.7rem",
                      padding: "0.5rem 1rem",
                      borderRadius: "0.6rem",
                      background: bucket.bg,
                      border: `1px solid ${bucket.border}`,
                      color: bucket.color,
                      fontFamily: "Inter-SemiBold",
                      whiteSpace: "nowrap",
                      boxShadow: `0 1px 2px ${bucket.border}`,
                      cursor: "default",
                    }}
                  >
                    <span
                      style={{
                        width: "0.8rem",
                        height: "0.8rem",
                        borderRadius: "50%",
                        background: bucket.color,
                        display: "inline-block",
                        flexShrink: 0,
                        boxShadow: `0 0 0 0.3rem ${bucket.bg}, 0 0 0 0.4rem ${bucket.border}`,
                      }}
                    />
                    <span
                      style={{
                        fontSize: "1.1rem",
                        color: "#667085",
                        fontWeight: 500,
                        fontFamily: "Inter-Medium",
                        textTransform: "uppercase",
                        letterSpacing: "0.05rem",
                      }}
                    >
                      Match
                    </span>
                    <span
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: 700,
                        lineHeight: 1,
                        fontFamily: "Inter-SemiBold",
                      }}
                    >
                      {copyLeadObj.leadfinalscore}
                    </span>
                  </div>
                </Tooltip>
              );
            })()}
            {copyLeadObj.status === "Unclaimed" &&
              loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.Claimed
                ?.isAccessible && (
                <div>
                  <Button
                    style={{
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      color: "#FFF",
                      backgroundColor: "#1570EF",
                    }}
                    padding={"1rem 3.6rem"}
                    btnName={"CLAIM"}
                    // clicked={claimLead}
                    clicked={handleClaimAndUpload}
                  />
                </div>
              )}
            {/* Lost leads: Regenerate is the only lead action, shown beside the
                standard Timeline-and-Notes three-dots menu (same modal as other tabs). */}
            {lostMode && (
              <div>
                <Button
                  style={{
                    fontSize: "1.4rem",
                    lineHeight: "2rem",
                    color: "#FFF",
                    backgroundColor: "#1570EF",
                  }}
                  padding={"1rem 3.6rem"}
                  btnName={"Regenerate"}
                  clicked={() => onRegenerate && onRegenerate(copyLeadObj)}
                />
              </div>
            )}
            <div>
              <ThreeDotsMenu
                list={lostMode ? ["Timeline and Notes"] : sortBy(dropdownList)}
                selectedValue={(e) => {
                  if (e === "Schedule site visit") {
                    setScheduleSiteVisitModal(true);
                  } else if (e === "Timeline and Notes") {
                    //open mdoal
                    setTimeLineAndNotesModal(true);
                  } else if (e === "Assign new token") {
                    setAssignNewTokenModal(true);
                  } else if (e === "Add Preference") {
                    setAddPreferenceModal(true);
                  } else if (e === "Add site visit") {
                    setAddSiteVisitModal(true);
                  } else if (e === "Change unit") {
                    setSelectedAllotment(null);
                    setChangeUnitModal(true);
                  } else if (e === "Cancel unit") {
                    setCancelUnitModal(true);
                    setSelectedAllotment(null);
                  } else if (e === "Update Status") {
                    setUpdateStatusModal(true);
                  } else if (e === "Reassign Lead") {
                    setReAssignLeadModal(true);
                    setAssignTitle("Reassign Lead");
                  } else if (e === "Assign Lead") {
                    setReAssignLeadModal(true);
                    setAssignTitle("Assign Lead");
                  } else if (e === "Churn and Create Lead") {
                    setChurnLeadModal(true);
                  } else if (e === "Alot Unit") {
                    setAlotUnitModal(true);
                  }
                  // else if (e === "Share virtual account details") {
                  //   // if (copyLeadObj?.razorpaycustomerid !== null) {
                  //   shareVirtualAccDetails();
                  //   // } else {
                  //   //   errorTost("Please create virtual account first");
                  //   // }
                  // } 
                  else if (e === "View virtual account details") {

                    setViewVirtualAccDetailsModal(true)

                  }
                  else if (e === "Create virtual account") {
                    //!! api remaining
                    createVirtualAccountFun();

                  } else if (e === "Close virtual account") {
                    //!! api remaining
                    getVirtualAcountStatus();
                  } else if (e === "Recreate virtual account") {
                    //!! api remaining
                    recreateAccount()
                  }
                  else if (e === "Check virtual account status") {
                    checkStatus();
                  }
                  else if (e === "View Details") {
                    setViewDetailsLeadRLModal(true);
                  } else if (e === "Lead Source Change") {
                    setLeadSourceChangeModal(true);
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className={cssClasses.content}>
          <div className={cssClasses.displayChip}>
            {copyLeadObj?.regeneratedFromLeadId &&
              <LeadStatusChip
                label={"Regenerated"}
                icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                style={{
                  color: "#0E9384",
                  backgroundColor: "#F0FDFA",
                }}
              />
            }
            {copyLeadObj?.lead_category &&
              <LeadStatusChip
                label={copyLeadObj?.lead_category}
                // icon={<Dot width={"0.5rem"} height={"0.5rem"}/>}
                style={{
                  color: "#A15C07",
                  backgroundColor: "#FEFDF0",
                }}
              />
            }
            {copyLeadObj?.leadvjop &&
              <LeadStatusChip
                label="VJOP"
                style={{
                  color: "rgb(180, 35, 24)",
                  backgroundColor: "rgb(254, 243, 242)",
                }}
              />
            }
            {copyLeadObj?.isleadunclaimed &&
              <div>
                <LeadStatusChip
                  label={"Lead Churned"}
                  icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                  style={{
                    color: "#b54708",
                    backgroundColor: "#fffaeb"
                  }}
                />
              </div>
            }
            {!lostMode &&
              tabValue !== "Unclaimed" &&
              tabValue !== "Nuturing" &&
              copyLeadObj?.status !== "Unclaimed" &&
              copyLeadObj?.status !== "Claimed" && (
                <div>
                  <LeadStatusChip
                    label={
                      copyLeadObj?.razorpaycustomerid || copyLeadObj?.virtualaccid
                        ? `Virtual Account Created ${copyLeadObj.virtual_acc_status === null ? "" : copyLeadObj.virtual_acc_status === "active" ? " - Active" : " - Closed"}`
                        : "Virtual Account Not Created"
                    }
                    icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                    style={
                      copyLeadObj?.razorpaycustomerid &&
                        copyLeadObj.virtual_acc_status === "closed"
                        ? {
                          color: "#b54708",
                          backgroundColor: "#fffaeb",
                        }
                        : copyLeadObj?.razorpaycustomerid === null
                          ? {
                            color: "#C01048",
                            backgroundColor: "#FFF1F3",
                          }
                          : {
                            color: "#027A48",
                            backgroundColor: "#ECFDF3",
                          }
                    }
                  />
                </div>
              )}
          </div>

          <div className={cssClasses.content1}>
            <div>
              <div
                className={cssClasses.rowWrapper}
                style={{ alignItems: "baseline", gap: "0.8rem" }}
              >
                <div className={cssClasses.leadName}>
                  <p>{copyLeadObj.person.name}</p>
                </div>
                <div className={cssClasses.leadId}>
                  <p>{copyLeadObj.id}</p>
                </div>
              </div>
              <div className={cssClasses.rowWrapper}>
                <div className={cssClasses.projectName}>
                  {/* Event Name | 60-70L | */}
                  <p>
                    {copyLeadObj.project.unitType} | {copyLeadObj.project.name}
                  </p>
                </div>
              </div>
              <div className={cssClasses.rowWrapper}>
                <div className={cssClasses.label} style={{ color: "#1D2939" }}>
                  <CalendarTodayOutlinedIcon style={{ color: "#1D2939" }} />
                  <p>Created At :</p>
                </div>
                <div
                  className={cssClasses.value}
                  style={{ color: "#344054", fontFamily: "Inter-Regular" }}
                >
                  <p>
                    {new Date(copyLeadObj.createdAt).toDateString()},{" "}
                    {new Date(copyLeadObj.createdAt).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                </div>
              </div>
            </div>
            <div>
              {copyLeadObj?.referrerid ? (
                <div>
                  <div className={cssClasses.rowWrapper}>
                    <div className={cssClasses.label}>
                      <p>Referrer</p>
                    </div>
                    <div className={cssClasses.label}>
                      <p>:</p>
                    </div>
                    <div className={cssClasses.value}>
                      <p>{copyLeadObj?.referrername || "NA"}</p>
                    </div>
                  </div>
                  <div className={cssClasses.rowWrapper}>
                    <div className={cssClasses.label}>
                      <p>Unit</p>
                    </div>
                    <div className={cssClasses.label}>
                      <p>:</p>
                    </div>
                    <div className={cssClasses.value}>
                      <p>
                        {copyLeadObj?.referrerunitno || "NA"} -
                        {copyLeadObj?.referrerwing || "NA"} |
                        {copyLeadObj?.referrerproject || "NA"}
                      </p>
                    </div>
                  </div>
                  <div className={cssClasses.rowWrapper}>
                    <div className={cssClasses.label}>
                      <p>Relationship Manager</p>
                    </div>
                    <div className={cssClasses.label}>
                      <p>:</p>
                    </div>
                    <div className={cssClasses.value}>
                      <p>{copyLeadObj?.referrerrelationshipm || "NA"}</p>
                    </div>
                  </div>
                  <div className={cssClasses.rowWrapper}>
                    <div className={cssClasses.label}>
                      <p>Referrer Type</p>
                    </div>
                    <div className={cssClasses.label}>
                      <p>:</p>
                    </div>
                    <div className={cssClasses.value}>
                      <p>{copyLeadObj?.referrertype ? copyLeadObj.referrertype : "-"}</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className={cssClasses.rowWrapper}>
                    <div className={cssClasses.label}>
                      <p>FOS</p>
                    </div>
                    <div className={cssClasses.label}>
                      <p>:</p>
                    </div>
                    <div className={cssClasses.value}>
                      {copyLeadObj.FOS.name === "-" ? (
                        <p>NA</p>
                      ) : (
                        <p>{copyLeadObj.FOS.name}</p>
                      )}
                    </div>
                  </div>
                  <div className={cssClasses.rowWrapper}>
                    <div className={cssClasses.label}>
                      <p>CP</p>
                    </div>
                    <div className={cssClasses.label}>
                      <p>:</p>
                    </div>
                    <div className={cssClasses.value}>
                      {copyLeadObj.CP.name === "-" ? (
                        <div
                          style={{
                            display: "flex",
                            gap: "1rem",
                          }}
                        >
                          <p>NA</p>
                          <span>
                            <Tooltip
                              title={
                                <h1 style={{ color: "lightblue" }}>
                                  Lead added by internal sales team hence no FOS or
                                  CP present
                                </h1>
                              }
                              disableInteractive
                              style={{ fontSize: "2.4rem" }}
                            >
                              <InfoOutlinedIcon
                                style={{
                                  fontSize: "2rem",
                                  verticalAlign: "middle",
                                  cursor: "pointer",
                                }}
                              />
                            </Tooltip>
                          </span>
                        </div>
                      ) : (
                        <p>{copyLeadObj.CP.name}</p>
                      )}
                    </div>
                  </div>
                </div>
              )
              }
              {leadObj?.status !== "Unclaimed" && (
                <div className={cssClasses.rowWrapper}>
                  <div className={cssClasses.label}><p>BA Name</p></div>
                  <div className={cssClasses.label}><p>:</p></div>
                  <div className={cssClasses.value}>
                    <p>
                      {copyLeadObj?.brandambassador && copyLeadObj.brandambassador !== "-"
                        ? copyLeadObj.brandambassador
                        : "No BA Assigned"}
                    </p>
                  </div>
                </div>
              )}
              {leadObj?.status !== "Unclaimed" && (
                <div className={cssClasses.rowWrapper}>
                  <div className={cssClasses.label}>
                    <p>VJ SM</p>
                  </div>
                  <div className={cssClasses.label}>
                    <p>:</p>
                  </div>
                  <div className={cssClasses.value}>
                    <p>{copyLeadObj.Sales.name}</p>
                  </div>
                </div>
              )}
            </div>
            {tabValue === "Closed" && (
              <div>
                <div className={cssClasses.rowWrapper}>
                  <div className={cssClasses.label}>
                    <p>Allotment Status</p>
                  </div>
                  <div className={cssClasses.label}>
                    <p>:</p>
                  </div>
                  <div className={cssClasses.value}>
                    <LeadStatusChip
                      style={{
                        color: style?.unitChipColor,
                        backgroundColor: style?.unitChipBackgroundColor,
                      }}
                      label={copyLeadObj.unit.status}
                      icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
                    />
                  </div>
                </div>
                <div className={cssClasses.rowWrapper}>
                  <div className={cssClasses.label}>
                    <CalendarTodayOutlinedIcon style={{ color: "#667085" }} />
                    <p>Allotment Date</p>
                  </div>
                  <div className={cssClasses.label}>
                    <p>:</p>
                  </div>
                  <div className={cssClasses.value}>
                    <p>
                      {/* {new Date(
                            copyLeadObj.unit.allotmentDate
                          ).toLocaleDateString()} */}
                      {new Date(copyLeadObj.unit.allotmentDate).toDateString()},{" "}
                      {new Date(
                        copyLeadObj.unit.allotmentDate
                      ).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          {showDetails &&
            copyLeadObj?.allotmentData?.map((eachAllotment) => {
              return (
                <div style={{ marginTop: "2rem" }}>
                  <Divider
                    sx={{
                      width: "100%",
                      borderColor: "#EAECF0",
                      marginBottom: "1.2rem",
                    }}
                  />
                  <div className={cssClasses.projectDiv}>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        alignItems: "center",
                      }}
                    >
                      <div className={cssClasses.projectNameLabel}>
                        <p>Project Name</p>
                      </div>
                      <div className={cssClasses.label}>
                        <p>:</p>
                      </div>
                      <div className={cssClasses.projectNameValue}>
                        {eachAllotment?.unitId?.projectId?.projectName ? (
                          <p>{eachAllotment?.unitId?.projectId?.projectName}</p>
                        ) : (
                          <p>
                            {
                              eachAllotment?.inventoryMergedId?.projectId
                                ?.projectName
                            }
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ display: "flex", gap: "0.5rem" }}>
                        <div>
                          {eachAllotment.pricingType === "preselect" && (
                            <LeadStatusChip
                              label={"Preselect"}
                              icon={
                                <Dot width={"0.5rem"} height={"0.5rem"} />
                              }
                              style={{ color: "#3538CD", backgroundColor: "#EEF4FF" }}
                            ></LeadStatusChip>
                          )}
                        </div>
                        <div>
                          {eachAllotment.farvisionCancelled?.cancelledInFarvision === true && (
                            <LeadStatusChip
                              label={"Cancelled In Farvision"}
                              icon={
                                <Dot width={"0.5rem"} height={"0.5rem"} />
                              }
                              style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                            ></LeadStatusChip>
                          )}
                        </div>
                        <div>

                          {(eachAllotment.status === "Partial Payment Done" ||
                            eachAllotment.status === "Payment Complete") &&
                            !eachAllotment.kycFormFilled && (
                              <LeadStatusChip
                                label={"Kyc pending"}
                                icon={
                                  <Dot width={"0.5rem"} height={"0.5rem"} />
                                }
                                style={{
                                  color: "#0E7090",
                                  backgroundColor: "#ECFDFF",
                                }}
                              ></LeadStatusChip>
                            )}
                          {eachAllotment.kycFormFilled && (
                            <LeadStatusChip
                              label={"Kyc Done"}
                              icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                              style={{
                                color: "#0E7090",
                                backgroundColor: "#ECFDFF",
                              }}
                            ></LeadStatusChip>
                          )}
                        </div>
                        {eachAllotment.CRM.length !== 0 && (
                          <div>
                            <LeadStatusChip
                              label={"CRM Tagged"}
                              icon={
                                <LocalOfferIcon
                                  width={"0.5rem"}
                                  height={"0.5rem"}
                                />
                              }
                              style={{
                                color: "#027A48",
                                backgroundColor: "#ECFDF3",
                              }}
                            />
                          </div>
                        )}
                        <div>
                          <LeadStatusChip
                            style={
                              eachAllotment?.status === "pending"
                                ? {
                                  color: "#B54708",
                                  backgroundColor: "#FFFAEB",
                                }
                                : eachAllotment?.status === "Payment Complete"
                                  ? {
                                    color: "#027A48",
                                    backgroundColor: "#ECFDF3",
                                  }
                                  : {
                                    color: "#B54708",
                                    backgroundColor: "#FFF4ED",
                                  }
                            }
                            label={eachAllotment?.status}
                            icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                          />
                        </div>
                      </div>
                      {/* {((eachAllotment?.status !== "released"||eachAllotment?.status !== "Released")&&(eachAllotment?.status !== "cancelled"||eachAllotment?.status !== "Cancelled")) && */}
                      <div>
                        <ThreeDotsMenu
                          list={eachAllotment?.subMenu}
                          selectedValue={(e) => {
                            console.log(e);
                            if (e === "Change unit") {
                              setSelectedAllotment(eachAllotment);
                              setChangeUnitModal(true);
                            }
                            if (e === "Cancel unit") {
                              setSelectedAllotment(eachAllotment);
                              setCancelUnitModal(true);
                            }
                          }}
                        />
                      </div>
                      {/* // } */}
                    </div>
                  </div>
                  <div className={cssClasses.projectDetails}>
                    <div style={{ marginTop: "1rem", width: "30%" }} className={cssClasses.allotmentEachBlock}>
                      <p>Unit</p>
                      {eachAllotment?.unitId !== null ? (
                        <CustomInput
                          value={
                            // eachAllotment?.unitId?.wingId?.wingName +
                            (eachAllotment?.unitId?.wingId?.displayName ? eachAllotment?.unitId?.wingId?.displayName : eachAllotment?.unitId?.wingId?.wingName) +
                            "-" +
                            eachAllotment?.unitId?.unitNo
                          }
                          disabled={true}
                        />
                      ) : (
                        <CustomInput
                          value={
                            // eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                            //   ?.wingName +
                            (eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                              ?.displayName ? eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                              ?.displayName : eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                              ?.wingName) +
                            "-" +
                            (eachAllotment?.inventoryMergedId?.unit1No) +
                            "," +
                            // eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                            //   ?.wingName +
                            (eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                              ?.displayName ? eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                              ?.displayName : eachAllotment?.inventoryMergedId?.unit1Id?.wingId
                              ?.wingName) +
                            "-" +
                            (eachAllotment?.inventoryMergedId?.unit2No)
                          }
                          disabled={true}
                        />
                      )}
                    </div>
                    <div style={{ marginTop: "1rem", width: "20%" }} className={cssClasses.allotmentEachBlock}>
                      <p>Allotment Date</p>
                      <CustomInput
                        // value={new Date(
                        //   eachAllotment?.last_updated_at
                        // ).toLocaleDateString()}
                        value={
                          new Date(eachAllotment?.created_at).toDateString()
                          // new Date( eachAllotment?.last_updated_at).toLocaleTimeString([], {
                          //   hour: "2-digit",
                          //   minute: "2-digit",
                          //  } )
                        }
                        disabled={true}
                      />
                    </div>
                    <div style={{ marginTop: "1rem", width: "15%" }} className={cssClasses.allotmentEachBlock}>
                      <p>Paid Amount</p>
                      {eachAllotment?.paidAmount ? (
                        <CustomInput
                          value={
                            "₹" + numberWithCommas(eachAllotment?.paidAmount)
                          }
                          disabled={true}
                        />
                      ) : (
                        <CustomInput
                          value={"₹" + eachAllotment?.paidAmount}
                          disabled={true}
                        />
                      )}
                    </div>
                    <div style={{ marginTop: "1rem", width: "15%" }} className={cssClasses.allotmentEachBlock}>
                      <p>Total Cost</p>
                      {eachAllotment?.unitCost?.total ? (
                        <CustomInput
                          value={
                            "₹" +
                            numberWithCommas(eachAllotment?.unitCost?.total)
                          }
                          disabled={true}
                        />
                      ) : (
                        <CustomInput
                          value={"₹0"}
                          disabled={true}
                        />
                      )}
                    </div>
                    <div style={{ marginTop: "1rem", width: "15%" }} className={cssClasses.allotmentEachBlock}>
                      <p>Basic Brokerage</p>
                      {eachAllotment?.unitCost?.bsp ? (
                        <CustomInput
                          value={
                            "₹" +
                            numberWithCommas(toCalculateValueFromPercent(new Date(eachAllotment?.created_at) >= new Date("2025-04-01") ? 3 : 2, eachAllotment?.unitCost?.bsp))
                          }
                          disabled={true}
                        />
                      ) : (
                        <CustomInput value={"₹0"} disabled={true} />
                      )}
                    </div>
                    <div
                      style={{ display: "flex", gap: "2rem" }}
                    // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
                    >
                      <a
                        href={`https://wa.me/${leadObj.leadcontactnumber}/?text=${eachAllotment.WhatsAppMessage}`}
                        data-action="share/whatsapp/share"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsappIcon size={32} round={true} />
                      </a>
                      {/* <a
                        href={`tel:+${leadObj.leadcontactnumber}`}
                        data-action="share/whatsapp/share"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <CallIcon style={{ width: "4rem", height: '4rem' }} size={32} round={true} />
                      </a> */}
                    </div>
                  </div>
                  <div
                    style={{ width: "100%", height: "100%", marginTop: "2rem" }}
                  ></div>
                </div>
              );
            })}
          {showDetails && leadToken.length > 0 && (
            <div style={{ width: "100%", height: "35rem" }}>
              <DataGrid
                rows={leadToken}
                columns={columns}
                pageSize={20}
                sx={[dataGridStyles]}
              />
            </div>
          )}
        </div>

        <div className={cssClasses.footer}>
          {
            //**In tabValue===All we need to show on status
            (copyLeadObj.status === "Token Payment Pending" ||
              copyLeadObj.status === "Token Partial Payment Done" ||
              copyLeadObj.status === "Token Payment Complete" ||
              copyLeadObj.status === "Preselect payment not done" ||
              copyLeadObj.status === "Token Refund Requested" ||
              copyLeadObj.status === "Token Refunded" ||
              copyLeadObj.status === "Token Refund Request Rejected" ||
              copyLeadObj.status === "Token Payment Not Done" ||
              copyLeadObj.status === "Allotment Partial Payment Done" ||
              copyLeadObj.status === "Allotment Refunded" ||
              copyLeadObj.status === "Allotment Payment Complete" ||
              copyLeadObj.status?.includes(
                "Cancellation Confirmation Pending"
              ) ||
              copyLeadObj.status === "Cancellation Done" ||
              copyLeadObj.status === "Cancellation Pending" ||
              copyLeadObj.status === "Cancellation Not Done" ||
              copyLeadObj.status === "Change Unit Confirmation Pending" ||
              copyLeadObj.status === "Allotment Payment Pending" ||
              copyLeadObj.status === "Payment Pending" ||
              copyLeadObj.status === "Unit On Hold" ||
              copyLeadObj.status === "PreSelect Payment Pending" ||
              copyLeadObj.status === "Preselect not confirmed" ||
              copyLeadObj.status === "PreSelect Unit On Hold" ||
              copyLeadObj.status === "PreSelect Confirmation Pending" ||
              copyLeadObj.status === "Unit Change Requested" ||
              copyLeadObj.status === "PreSelect Price Confirmation Pending" ||
              copyLeadObj.status === "PreSelect Partial Payment Done" ||
              copyLeadObj.status === "Checkpoint One Cleared" ||
              copyLeadObj.status === "Checkpoint Two Cleared" ||
              copyLeadObj.status === "Change Unit Requested" ||
              copyLeadObj.status === "Change Unit Confirmation Pending" ||
              copyLeadObj.status === "Change Unit Confirmation Rejected" ||
              copyLeadObj.status === "Change Unit Confirmed" ||
              copyLeadObj.status === "Change Unit Rejected" ||
              copyLeadObj.status === "Site Visit Done" ||
              copyLeadObj.status === "Allotment Done" ||
              copyLeadObj.status === "Agreement Done") && (
              <div>
                <Box>
                  {!showDetails ? (
                    <Button
                      iconPosition={"right"}
                      padding={"0.5rem"}
                      clicked={() => {
                        setShowDetails(true);
                        // if (tabValue === "Token" || tabValue === "Token" || tabValue === "Allotment" || tabValue === "All") {
                        if (CardType !== "TokenHolders") {
                          getLeadAlotedProject();
                        }

                        // }
                        getLeadAssignedToken();
                      }}
                      btnName={"More Details"}
                      style={{
                        color: "#1570EF",
                        borderRadius: "2.4rem",
                        backgroundColor: "#EFF8FF",
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        border: "1px solid #EFF8FF",
                      }}
                      btnIcon={
                        <KeyboardArrowDownIcon
                          style={{
                            color: "#1570EF",
                            width: "3rem",
                            height: "3rem",
                          }}
                        />
                      }
                    />
                  ) : (
                    <Button
                      iconPosition={"right"}
                      padding={"0.5rem"}
                      clicked={() => setShowDetails(false)}
                      btnName={"Hide Details"}
                      style={{
                        color: "#1570EF",
                        borderRadius: "2.4rem",
                        backgroundColor: "#EFF8FF",
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                        border: "1px solid #EFF8FF",
                      }}
                      btnIcon={
                        <KeyboardArrowUpIcon
                          style={{
                            color: "#1570EF",
                            width: "3rem",
                            height: "3rem",
                          }}
                        />
                      }
                    />
                  )}
                </Box>
              </div>
            )
          }
          {!lostMode && (
            copyLeadObj.status === "Claimed" ||
            copyLeadObj.status === "Site Visit Scheduled" ||
            copyLeadObj.status === "Site Visit Done") && (
              <div
                style={{
                  display: "flex",
                  gap: "2rem",
                  alignItems: 'center'
                }}
              // style={tabValue==='Unclaimed'||tabValue==='Nuturing'||tabValue==='Site Visit'?{width:"100%",textAlign:'right'}:{}}
              >
                <a
                  href={`https://wa.me/${leadObj.leadcontactnumber}/?text=${WhatsAppMessage}`}
                  data-action="share/whatsapp/share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsappIcon size={32} round={true} />
                </a>
                <a
                  href={`tel:+${leadObj.leadcontactnumber}`}
                  data-action="share/whatsapp/share"
                  target="_blank"
                  rel="noopener noreferrer"
                >

                  <CallIcon
                    style={{ width: "3rem", height: "3rem" }}
                    round={true}
                    onClick={(e) => handleCall(e)}
                  />
                </a>
              </div>
            )}

          {(copyLeadObj.status === "Token Payment Complete" ||
            copyLeadObj.status === "Token Payment Pending" ||
            copyLeadObj.status === "Checkpoint Two Cleared" ||
            copyLeadObj.status === "Token Refund Requested" ||
            copyLeadObj.status === "Token Payment Not Done" ||
            copyLeadObj.status === "PreSelect Unit On Hold" ||
            copyLeadObj.status === "Allotment Payment Complete" ||
            copyLeadObj.status === "Allotment Payment Pending" ||
            copyLeadObj.status === "Cancellation Done" ||
            copyLeadObj.status === "Unit On Hold" ||
            copyLeadObj.status === "Allotment Partial Payment Done" ||
            copyLeadObj.status === "Allotment Refunded" ||
            copyLeadObj.status === "Payment Pending" ||
            copyLeadObj.status === "PreSelect Confirmation Pending" ||
            copyLeadObj.status === "Unit Change Requested" ||
            copyLeadObj.status === "Checkpoint One Cleared" ||
            copyLeadObj.status === "Agreement Done") && (
              <a
                href={`tel:+${leadObj.leadcontactnumber}`}
                data-action="share/whatsapp/share"
                target="_blank"
                rel="noopener noreferrer"
              >

                <CallIcon
                  style={{ width: "3rem", height: "3rem" }}
                  size={32}
                  round={true}
                  onClick={handleCall}
                />
              </a>
            )}
        </div>
      </div>
      {scheduleSiteVisitModal && (
        <ScheduleSiteVisit
          open={scheduleSiteVisitModal}
          handleClose={() => {
            setScheduleSiteVisitModal(false);
          }}
          data={copyLeadObj}
          returnRes={returnRes}
        />
      )}

      {timeLineAndNotesModal && (
        <TimeLineAndNotes
          open={timeLineAndNotesModal}
          handleClose={() => {
            setTimeLineAndNotesModal(false);
          }}
          data={leadObj}
        />
      )}
      {assignNewTokenModal && (
        <AssignNewToken
          open={assignNewTokenModal}
          handleClose={() => {
            setAssignNewTokenModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {addPreferenceModal && (
        <AddPreference
          open={addPreferenceModal}
          handleClose={() => {
            setAddPreferenceModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {changeTokenModal && (
        <ChangeToken
          open={changeTokenModal}
          changeTokenPassData={changeTokenPassData}
          handleClose={() => {
            setChangeTokenModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {addSiteVisitModal && (
        <AddSiteVisit
          open={addSiteVisitModal}
          handleClose={() => {
            setAddSiteVisitModal(false);
          }}
          data={leadObj}
          modalType={"leadSiteVisit"}
          returnRes={returnRes}
        />
      )}
      {changeUnitModal && (
        <ChangeUnit
          open={changeUnitModal}
          handleClose={() => {
            setChangeUnitModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
          selectedAllotment={selectedAllotment}
        />
      )}
      {cancelUnitModal && (
        <CancelUnit
          open={cancelUnitModal}
          handleClose={() => {
            setCancelUnitModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
          selectedAllotmentPass={selectedAllotment}
        />
      )}
      {refundTokenModal && (
        <RefundToken
          open={refundTokenModal}
          handleClose={() => {
            setRefundTokenModal(false);
          }}
          refundTokenData={refundTokenData}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {updateStatusModal && (
        <UpdateLeadStatus
          open={updateStatusModal}
          handleClose={() => {
            setUpdateStatusModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {reAssignLeadModal && (
        <ReAssignLead
          open={reAssignLeadModal}
          handleClose={() => {
            setReAssignLeadModal(false);
          }}
          data={leadObj}
          modalTitle={assignTitle}
          returnRes={returnRes}
        />
      )}
      {churnLeadModal && (
        <ChurnLeadRejection
          open={churnLeadModal}
          handleClose={() => {
            setChurnLeadModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {alotUnitModal && (
        <AlotUnit
          open={alotUnitModal}
          handleClose={() => {
            setAlotUnitModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
          oldAllotmentData={null}
        />
      )}
      {updateLeadDetailsModal && (
        <UpdateLeadDetails open={updateLeadDetailsModal}
          handleClose={() => {
            setUpdateLeadDetailsModal(false);
          }}
          data={leadObj}
          returnRes={returnRes}
        />
      )}
      {virtualAccountStatusModal && (
        <CheckVirtualAccountStatus
          open={virtualAccountStatusModal}
          handleClose={() => {
            setVirtualAccountStatusModal(false);
          }}
          virtualAccountStatus={virtualAccountStatus}
          recreateAccount={recreateAccount}
        />
      )}
      {showCloseVirtualAccModal && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              closeVirtualAccountFun();
            }
          }}
          buttonTitle={"No"}
          returnRespButton={"Yes"}
          close={() => setShowCloseVirtualAccModal(false)}
          title={"Warning"}
          subTitle={closeVirtualAccMsg}
          open={showCloseVirtualAccModal}
        />
      )}
      {
        viewVirtualAccDetailsModal && (
          <ViewVirtualAccDetails
            open={viewVirtualAccDetailsModal}
            handleClose={() => { setViewVirtualAccDetailsModal(false) }}
            data={leadObj}
          />
        )
      }
      {leadSourceChangeModal && (
        <LeadSourceChange
          open={leadSourceChangeModal}
          handleClose={() => setLeadSourceChangeModal(false)}
          data={copyLeadObj}
          returnRes={returnRes}
        />
      )}
      {viewDetailsLeadRLModal && (

        <ViewLeadDetailsRL
          open={viewDetailsLeadRLModal}
          handleClose={() => {
            setViewDetailsLeadRLModal(false);
          }}
          data={JSON.parse(leadObj.referrerdetails_leads_table)}
          dataAll={leadObj}
          referalDetailsData={JSON.parse(leadObj?.referrerdetails_leads_referral_table)}
        />
      )}
    </Card>
  );
}


